import { defineComponent } from 'vue';
import { createTeleport } from '#layers/base/public';

const [provideHeaderActions, RenderPageHeaderActions, TeleportPageHeaderActions] = createTeleport('PageHeaderActions');
const [provideActions, RenderPageActions, TeleportPageActions] = createTeleport('PageActions');

export {
	RenderPageActions,
	RenderPageHeaderActions,
	TeleportPageActions,
	TeleportPageHeaderActions,
};

export const PageSlotProvider = defineComponent({
	setup(_, { slots }) {
		provideHeaderActions();
		provideActions();

		return () => slots.default?.();
	},
});
